module.exports = __webpack_public_path__ + "static/collaboration-1-d0e912124ca69096ea0b9e676c914efb.svg";